const id_master_customer = {
    add: "tambah pelanggan",
    address: "alamat pelanggan",
    edit: "ubah pelanggan",
    email: "email pelanggan",
    name: "nama pelanggan",
    phone: "telepon pelanggan",
    upload: "unggah pelanggan",

    form: {
        ppn_label: "Aktifkan untuk menggunakan PPN",
        upload_title: "input data pelanggan",
        coa: "COA Piutang",
    },

    message: {
        note_upload: "CATATAN : hanya format excel yang bisa diunggah !",
        note_excel: "Unduh contoh file Excel pelanggan",
        note_term_title: "Ketentuan file:",
        note_term_1: "Gunakan file contoh.",
        note_term_2: "Kolom yang terdapat tanda '*' wajib diisi",
        note_term_3: "Nama Pelanggan : harus diisi dan jika sudah ada di database tidak bisa diisi ulang. cth: pelanggan1, pelanggan2, pelanggan3,",
        note_term_4: "Isi kolom PPN dengan : 1 (menggunakan PPN), 0 (tidak menggunakan PPN)",
    },

    error: {
        create: "Gagal membuat pelanggan.",
        delete: "Gagal menghapus pelanggan.",
        edit: "Gagal mengubah pelanggan.",
    },

    success: {
        create: "Berhasil membuat pelanggan.",
        delete: "Berhasil menghapus pelanggan.",
        edit: "Berhasil mengubah pelanggan.",
    }
}

export default id_master_customer;